/**
 * Projects Service
 * 專案基本資料 - API 呼叫服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';
import {
  Project,
  ProjectCreate,
  ProjectUpdate,
  ProjectFilters
} from '../types/projects';

const BASE_URL = '/api/projects';

/**
 * 查詢專案資料列表
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getAll = async (
  filters?: ProjectFilters
): Promise<Project[]> => {
  const response = await axios.get(`${BASE_URL}/`, { params: filters });
  return response.data;
};

/**
 * 根據 ID 查詢單筆專案資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getById = async (id: number): Promise<Project> => {
  const response = await axios.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * 新增專案資料
 * axios 攔截器會自動添加 X-Txn-Token header
 * @param data 新增資料
 */
export const create = async (
  data: ProjectCreate
): Promise<Project> => {
  const response = await axios.post(`${BASE_URL}/`, data);
  return response.data;
};

/**
 * 更新專案資料
 * axios 攔截器會自動添加 X-Txn-Token header
 * @param id 專案資料 ID
 * @param data 更新資料
 */
export const update = async (
  id: number,
  data: ProjectUpdate
): Promise<Project> => {
  const response = await axios.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

/**
 * 刪除專案資料
 * axios 攔截器會自動添加 X-Txn-Token header
 * @param id 專案資料 ID
 */
export const deleteById = async (
  id: number
): Promise<void> => {
  await axios.delete(`${BASE_URL}/${id}`);
};

const projectsService = {
  getAll,
  getById,
  create,
  update,
  deleteById
};

export default projectsService;
